export const ContentWidth = {
  Fluid: 'fluid',
  Boxed: 'boxed',
} as const

export const NavbarType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const FooterType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const AppContentLayoutNav = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
} as const

export const HorizontalNavType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const


export enum ServiceCategory {
  Haircut = 'Haarschnitt',
  Coloring = 'Färben',
  Styling = 'Styling',
  Washing = 'Waschen',
  Blowdry = 'Föhnen',
  Updo = 'Hochsteckfrisur',
  BeardCare = 'Bartpflege',
  Eyebrows = 'Augenbrauen',
  Manicure = 'Maniküre',
  Pedicure = 'Pediküre',
  FacialTreatment = 'Gesichtsbehandlung',
  Massage = 'Massage',
  Waxing = 'Waxing',
  PermanentMakeup = 'Permanent Make-up',
  HairStraightening = 'Haarglättung',
  ScalpTreatment = 'Kopfhautbehandlung',
  ChildrenHaircut = 'Kinderhaarschnitt',
  BridalHairstyle = 'Brautfrisur',
  HairConsultation = 'Haarberatung',
  Other = 'Andere'
}

export const ServiceCategoryIcon = {
  Haircut: 'ri-scissors-cut-line',
  Coloring: 'ri-palette-line',
  Styling: 'ri-brush-line',
  Washing: 'ri-water-flash-line',
  Blowdry: 'ri-windy-line',
  Updo: 'ri-flower-line',
  BeardCare: 'ri-scissors-line',
  Eyebrows: 'ri-eye-line',
  Manicure: 'ri-hand-heart-line',
  Pedicure: 'ri-footprint-line',
  FacialTreatment: 'ri-face-line',
  Massage: 'ri-heart-pulse-line',
  Waxing: 'ri-drop-line',
  PermanentMakeup: 'ri-ink-bottle-line',
  HairStraightening: 'ri-ruler-line',
  ScalpTreatment: 'ri-microscope-line',
  ChildrenHaircut: 'ri-user-smile-line',
  BridalHairstyle: 'ri-heart-line',
  HairConsultation: 'ri-chat-1-line',
  Other: 'ri-more-line',
} as const;

export enum TransactionStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  CANCELED = "canceled",
}

export enum UserRole {
  ADMIN = "admin",
  EMPLOYEE = "employee",
  CUSTOMER = "customer",
}

export enum ReminderType {
  REVIEW = "review",
  REMINDER = "reminder",
}

export enum Plan {
  BASIC = "basic",
  PRO = "pro",
  ENTERPRISE = "enterprise",
}

export enum AppointmentStatus {
  CONFIRMED = "confirmed",
  CANCELED = "canceled",
  PENDING = "pending",
}

